import sessionActions from "csi/sessionActions";
import sessionConstants from "csi/sessionConstants";

/** Store idle timer ID */
let idleTimerId:number;

/** 
 * Key for local storage entry, we call this directly instead of using 
 * localStore to make this work across browser tabs.
 */
const LAST_INPUT_ACTION_TIME = "LastInputActionTime";
	
/**
 * Initializes the idle session timer and event listeners if the Idle Expiration Time is non-zero.  
 * Any user mouse or keyboard activity will reset the timeout.
 * This setting is configured on the server.
 */
export function sessionIdleInit(): void {
	// If idle expiration time is set then track user activity to prevent logout
	if (sessionConstants.idleExpirationTime) {
		initIdleTimer();
		window.addEventListener("mousemove", resetLastActivityTime);
		window.addEventListener("mousedown", resetLastActivityTime);
		window.addEventListener("touchstart", resetLastActivityTime);
		window.addEventListener("click", resetLastActivityTime);
		window.addEventListener("keydown", resetLastActivityTime);
	}
}

/**
 * Initializes the idle timer interval to one second and sets the last activity time to now
 */
function initIdleTimer(): void {
	idleTimerId = window.setInterval(closeSessionIfIdle, 1000);
	resetLastActivityTime();
}

/**
 * Sets the last user activity time to now
 */
function resetLastActivityTime(): void {
	window.localStorage.setItem(LAST_INPUT_ACTION_TIME, Date.now().toString());
}

/**
 * Checks if any user input has been detected and closes the session if the last activity
 * threshold is greater than the timeout period.
 */
function closeSessionIfIdle(): void {
	const lastInputActionTimeStr = window.localStorage.getItem(LAST_INPUT_ACTION_TIME);
	if (lastInputActionTimeStr) {
		const lastInputActionTime = parseInt(lastInputActionTimeStr);

		if (lastInputActionTime && Date.now() - lastInputActionTime > sessionConstants.idleExpirationTime) {
			// clean up timer
			console.log("Session idle timeout reached. Logging out user.");
			clearInterval(idleTimerId);
			window.localStorage.removeItem(LAST_INPUT_ACTION_TIME);
			sessionActions.logoutAction();
		}
	}
}